export default "__VITE_ASSET__30Wct9U4__"